// extracted by mini-css-extract-plugin
export default {"additionalSettingsSection":"PropertyDefinitionForm-module__additionalSettingsSection__RKskzM7","propertyFormControl":"PropertyDefinitionForm-module__propertyFormControl__I_1aFTY"};